import { render, staticRenderFns } from "./royalty.vue?vue&type=template&id=23fa4b40&scoped=true&"
import script from "./royalty.vue?vue&type=script&lang=js&"
export * from "./royalty.vue?vue&type=script&lang=js&"
import style0 from "./royalty.vue?vue&type=style&index=0&id=23fa4b40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa4b40",
  null
  
)

export default component.exports